import React from "react";
import { Search, ShoppingBasket } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Navbar = () => {
  const { cart } = useSelector((state) => state);
  return (
    <div className="bg-blue-100" >
      <nav className="flex items-center justify-between h-20  max-w-6xl mx-auto ">
        <Link to={"/"}>
          <div className="ml-5">
            <h1 className="bg-gradient-to-br from-violet-900 to-purple-300 bg-clip-text text-transparent text-xl sm:text-2xl md:text-3xl font-bold logo cursor-pointer tracking-wider">
              myshop
            </h1>
          </div>
        </Link>
        <div className="flex list-none items-center space-x-6 mr-5 text-gray-700 -tracking-tighterr font-semibold">
          <div className="relative flex items-center">
          <input type="text" className="w-full p-2 pl-10 pr-4 rounded-lg shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500 focus:ring-2 focus:outline-none" placeholder="Search..." />
          <Search className="  hover:text-purple-600 transition transform duration-200 h-5 w-5 absolute left-3 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
           <path fillRule="evenodd" d="M14.293 13.707a1 1 0 01-1.414 0l-3.182-3.182A5.5 5.5 0 106.5 8a5.5 5.5 0 005.707 5.325l3.182 3.182a1 1 0 010 1.414zM6.5 10a3.5 3.5 0 110 7 3.5 3.5 0 010-7z" clipRule="evenodd" />
          </Search>
        </div>

          <Link to={"/"}>
            <li className="cursor-pointer hover:text-purple-500 transition duration-300 ease-in">
              Home
            </li>
          </Link>
          <p className=" flex flex-col font-extrabold md:text-xs cursor-pointer  hover:text-purple-500 transition duration-300 ease-in   ">
            <span className="font-thin">Hey koushik</span>
               <strong className="font-bold">  Account&Lists  </strong>
            </p>
          <Link to={"/cart"}>
            <div className="relative">
              <ShoppingBasket className="text-2xl cursor-pointer hover:text-purple-600 transition transform duration-200" />

              {cart.length > 0 && (
                <div className="absolute bg-purple-600 text-xs w-5 h-5 flex justify-center items-center animate-bounce -top-1 -right-2 rounded-full top- text-white">
                  {cart.length}
                </div>
              )}
            </div>
          </Link>
        </div>
      </nav>
      <hr />
      <div className="flex items-center space-x-3 p-2 pl-6 bg-blue-200 text-sm ">
       <p className="flex items-center cursor-pointer hover:underline ">
        ALL
       </p>
       <p className="cursor-pointer hover:underline">Men</p>
       <p className="cursor-pointer hover:underline">WoMen</p>
       <p className="cursor-pointer hover:underline">Kids</p>
       <p className="cursor-pointer hover:underline">Beauty</p>
       <p className="cursor-pointer hover:underline hidden md:inline-flex ">TopBrands</p>
       <p className="cursor-pointer hover:underline hidden md:inline-flex">NewArrival</p>
       <p className="cursor-pointer hover:underline hidden md:inline-flex">Seasonal</p>
       <p className="cursor-pointer hover:underline"><Link to={"/items"}>ITEMS</Link></p>
       

    </div>
    </div>
  );
};

export default Navbar;
